export default function (str) {
    var isLangKeyRegex = /^[a-z]+(\.[a-z0-9-_]+)+$/i;
    return isLangKeyRegex.test(str);
}
